'use client';
import Box from '@mui/material/Box';
import { useTranslate } from '@tolgee/react';
import SimpleIconsDiscord from '../icons/SimpleIconsDiscord';
import SimpleIconsWechat from '../icons/SimpleIconsWechat';
import WeChatQRCodes from './WeChatQRCodes';

interface CommunityUIProps {
  publicQrSrc: string;
  groupQrSrc: string;
}

export default function CommunityUI({ publicQrSrc, groupQrSrc }: CommunityUIProps) {
  const { t } = useTranslate();
  return (
    <div id="community" className="flex flex-col items-stretch justify-center gap-8 md:flex-row">
      {/* Discord Card */}
      <div className="group relative mx-auto w-full max-w-md md:mx-0 md:w-auto">
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#5865F2]/30 to-[#7289DA]/30 opacity-50 blur-[10px] transition-all duration-300 [@media(hover:hover)]:group-hover:opacity-70"></div>
        <div className="relative z-10 flex h-full flex-col overflow-hidden rounded-2xl border border-[#5865F2]/20 bg-gradient-to-br from-[#1a1b26] to-[#24252d] p-6 shadow-xl">
          <div className="mb-4 flex items-center">
            <div className="mr-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#5865F2] text-white">
              <Box
                component={SimpleIconsDiscord}
                width={24}
                height={24}
                className="text-white"
                style={{ filter: 'brightness(0) invert(1)' }}
              />
            </div>
            <h3 className="text-xl font-bold text-white">Discord</h3>
          </div>

          <p className="mb-6 flex text-gray-300">{t('discord.description')}</p>

          <div className="mt-auto flex flex-grow items-center justify-center">
            <a
              href="https://discord.gg/frrmUpUeSb"
              target="_blank"
              rel="noopener noreferrer"
              className="group/button relative inline-flex w-full items-center justify-center overflow-hidden rounded-xl bg-[#5865F2] px-6 py-3 text-sm font-semibold text-white"
            >
              <span className="absolute inset-0 bg-gradient-to-r from-[#5865F2] to-[#7289DA] opacity-0 transition-opacity duration-300 group-hover/button:opacity-100"></span>
              <span className="absolute inset-0 bg-[#5865F2] transition-opacity duration-300 group-hover/button:opacity-0"></span>
              <span className="relative z-10 flex items-center justify-center">
                <Box
                  component={SimpleIconsDiscord}
                  width={20}
                  height={20}
                  className="mr-2"
                  style={{ filter: 'brightness(0) invert(1)' }}
                />
                <span>{t('discord.button_text')}</span>
              </span>
              <span className="absolute bottom-0 left-0 h-[2px] w-full origin-left scale-x-0 transform bg-white/20 transition-transform duration-300 group-hover/button:scale-x-100"></span>
            </a>
          </div>
        </div>
      </div>

      {/* WeChat Card */}
      <div className="group relative mx-auto w-full max-w-lg md:mx-0 md:w-auto">
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#07C160]/30 to-[#11A453]/30 opacity-50 blur-[10px] transition-all duration-300 [@media(hover:hover)]:group-hover:opacity-70"></div>
        <div className="relative z-10 flex h-full flex-col overflow-hidden rounded-2xl border border-[#07C160]/20 bg-gradient-to-br from-[#1a1b26] to-[#24252d] p-6 shadow-xl">
          <div className="mb-3 flex items-center">
            <div className="mr-4 flex h-12 w-12 items-center justify-center rounded-full bg-[#07C160] text-white">
              <Box component={SimpleIconsWechat} width={24} height={24} style={{ filter: 'brightness(0) invert(1)' }} />
            </div>
            <h3 className="text-xl font-bold text-white">{t('wechat.title')}</h3>
          </div>

          <p className="mb-4 text-gray-300">{t('wechat.community_description')}</p>

          <div className="mt-auto flex justify-center">
            <WeChatQRCodes publicQrSrc={publicQrSrc} groupQrSrc={groupQrSrc} />
          </div>
        </div>
      </div>
    </div>
  );
}
